import { render } from "./SiteLoader.vue?vue&type=template&id=133d0418"
import script from "./SiteLoader.vue?vue&type=script&lang=js"
export * from "./SiteLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__